import React from 'react'

import {
  array, number,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import EmptyInbox from './Components/EmptyInbox/EmptyInbox'
import Inbox from './Components/Inbox/Inbox'

function MessagesWidget({ messages, included = EMPTY_ARRAY, unreadCount = 0 }) {
  return (
    <span>
      {messages.length > 0
        ? <Inbox messages={messages} included={included} unreadCount={unreadCount} />
        : <EmptyInbox />}
    </span>
  )
}

MessagesWidget.propTypes = {
  messages: array.isRequired,
  included: array,
  unreadCount: number,
}

export default MessagesWidget
